/* 
  Custom Page State
  Manages the state of custom pages in the application.
  This includes the list of pages and the currently selected page.

  Redux for custom pages is because we will create, edit, and delete custom pages.
*/

import { PageItem } from 'system/types/interfaces/IAdvancedReporting';

export interface ICustomPagesState {
  pages:         PageItem[];
  currentPageId: number | null;
}

const customPagesState: ICustomPagesState = {
  pages:         [],
  currentPageId: null,
};

export default customPagesState;